export default {"src":"/_next/static/media/profile-details.75b82a00.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};